import { useState } from "react";

import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { useNavigate } from "react-router-dom";

import TransactionLedger from "../../src/modules/liveLedger/components/TransactionLedger";
import { LIVE_LEDGER_ROUTE } from "../../src/modules/liveLedger/routes";
import { EmptyTransactionState } from "../RecentTransactionsTable";
import styles from "./RecentTransactionsLedgerModule.module.scss";

import type {
  TransactionLedgerColumnId,
  TransactionLedgerFilterId,
} from "../../src/modules/liveLedger/components/TransactionLedger";

const MODULE_COLUMNS: TransactionLedgerColumnId[] = [
  "date",
  "description",
  "account",
  "amount",
];

const MODULE_FILTERS: TransactionLedgerFilterId[] = [
  "accounts",
  "amount",
  "date-range",
  "type",
];

const MODULE_PAGE_SIZE = 10;
const MODULE_PAGE_SIZE_OPTIONS = [5, 10, 15];

type RecentTransactionsLedgerModuleProps = {
  replyTime: string;
};

const RecentTransactionsLedgerModule = ({
  replyTime,
}: RecentTransactionsLedgerModuleProps) => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();
  const [filterState, setFilterState] = useState<Record<string, string>>({});
  const queryString = new URLSearchParams(filterState).toString();
  const viewAllPath = `/${LIVE_LEDGER_ROUTE}${
    queryString ? `?${queryString}` : ""
  }`;
  return (
    <div
      className={styles.module}
      data-testid="recent-transactions-ledger-module"
    >
      <div className={styles.moduleHeader}>
        <h4 className={styles.moduleTitle}>
          {l10n.getString("recent-transactions-module-header")}
        </h4>
        <Button
          kind="tonal"
          size="xs"
          endIcon="arrow-right"
          label={l10n.getString("recent-transactions-view-all")}
          onClick={() => navigate(viewAllPath)}
          testId="recent-transactions-view-all"
        />
      </div>
      <div className={styles.ledger}>
        <TransactionLedger
          columns={MODULE_COLUMNS}
          pagination={{
            enabled: true,
            pageSize: MODULE_PAGE_SIZE,
            pageSizeOptions: MODULE_PAGE_SIZE_OPTIONS,
          }}
          receipts
          filters={MODULE_FILTERS}
          filtersAlwaysVisible
          search="chip"
          stateStorage="local"
          onFilterStateChange={setFilterState}
          summary={false}
          emptyState={<EmptyTransactionState />}
          replyTime={replyTime}
        />
      </div>
    </div>
  );
};

export default RecentTransactionsLedgerModule;
